import React from "react";
// import "./styles.css";
import Register from "./Components/Register";
import Zones from "./Components/Zones";
import RelaxingZones from "./Components/RelaxingZones";
import Dashboard from "./Components/Dashboard";
// import Dashboard2 from "./Components/Dashboard2";
import Query from "./Components/Query";
import Violations from "./Components/Violations";
import Maps from "./Components/Maps"
import Login from "./Components/Login"
// import Login from "./Components/Login";
import { Route, Switch } from "react-router-dom";
import SideDrawer from "./Components/SideDrawer";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  container: {
    display: "flex"
  }
});
const DashboardScreen = () => {
  return (
    <>
      <SideDrawer />
    <Switch>
      <Route exact path="/dashboard" render={props => <Dashboard {...props} />} />
    </Switch>
    </>
  )
}

const RelaxingZonesScreen = () => {
  return (
    <>
      <SideDrawer />
    <Switch>
      <Route exact path="/relaxingZones" render={props => <RelaxingZones {...props} />} />
    </Switch>
    </>
  )
}
const ZonesScreen = () => {
  return (
    <>
      <SideDrawer />
    <Switch>
      <Route exact path="/zones" render={props => <Zones {...props} />} />
    </Switch>
    </>
  )
}
const QueryScreen = () => {
  return (
    <>
      <SideDrawer />
    <Switch>
      <Route exact path="/query" render={props => <Query {...props} />} />
    </Switch>
    </>
  )
}
const RegisterScreen = () => {
  return (
    <>
      <SideDrawer />
    <Switch>
      <Route exact path="/register" render={props => <Register {...props} />} />
    </Switch>
    </>
  )
}
const ViolationsScreen = () => {
  return (
    <>
      <SideDrawer />
    <Switch>
      <Route exact path="/violations" render={props => <Violations {...props} />} />
    </Switch>
    </>
  )
}
const MapsScreen = () => {
  return (
    <>
      <SideDrawer />
    <Switch>
      <Route exact path="/maps" render={props => <Maps {...props} />} />
    </Switch>
    </>
  )
}
export default function App() {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {/* <Login/> */}
      {/* <SideDrawer /> */}
      <Switch>
        <Route exact from="/" render={props => <Login {...props} />} />
        <Route exact path="/dashboard" render={props => <DashboardScreen {...props} />} />
        {/* <Route exact path="/dashboard2" render={props => <DashboardScreen1 {...props} />} /> */}
        <Route exact path="/relaxingzones" render={props => <RelaxingZonesScreen {...props} />} />
        <Route exact path="/zones" render={props => <ZonesScreen {...props} />} />
        <Route exact path="/query" render={props => <QueryScreen {...props} />} />
        <Route exact path="/register" render={props => <RegisterScreen {...props} />} />
        <Route exact path="/violations" render={props => <ViolationsScreen {...props} />} />
        <Route exact path="/maps" render={props => <MapsScreen {...props} />} />

      </Switch>
    </div>
  );
}


// import React from "react";
// // import "./styles.css";
// import Register from "./Components/Register";
// import Zones from "./Components/Zones";
// import RelaxingZones from "./Components/RelaxingZones";
// import Dashboard from "./Components/Dashboard";
// import Query from "./Components/Query";
// import Violations from "./Components/Violations";
// import Maps from "./Components/Maps"
// import Login from "./Components/Login"
// // import Login from "./Components/Login";
// import { Route, Switch } from "react-router-dom";
// import SideDrawer from "./Components/SideDrawer";
// import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles({
//   container: {
//     display: "flex"
//   }
// });
// const Testing1 = () => {
//   return (
//     <>
//       <SideDrawer />
//     <Switch>
//       <Route exact from="/" render={props => <Dashboard {...props} />} />
//       <Route exact path="/zones" render={props => <Zones {...props} />} />
//       <Route exact path="/relaxingzones" render={props => <RelaxingZones {...props} />} />
//       <Route exact path="/maps" render={props => <Maps {...props} />} />
//       <Route exact path="/violations" render={props => <Violations {...props} />} />
//       <Route exact path="/query" render={props => <Query {...props} />} />
//       <Route exact path="/register" render={props => <Register {...props} />} />
//     </Switch>
//     </>
//   )
// }
// export default function App() {
//   const classes = useStyles();
//   return (
//     <div className={classes.container}>
//       {/* <Login/> */}
//       {/* <SideDrawer /> */}
//       <Switch>
//         <Route exact from="/login" render={props => <Login {...props} />} />
//         <Route exact path="/" render={props => <Testing1 {...props} />} />
//         {/* <Route exact path="/relaxingzones" render={props => <RelaxingZones {...props} />} />
//         <Route exact path="/maps" render={props => <Maps {...props} />} />
//         <Route exact path="/violations" render={props => <Violations {...props} />} />
//         <Route exact path="/query" render={props => <Query {...props} />} />
//         <Route exact path="/register" render={props => <Register {...props} />} /> */}
//       </Switch>
//     </div>
//   );
// }